import React from 'react'
import { css } from '@emotion/core'
import { useTranslation } from 'react-i18next'
import { func } from 'prop-types'
import { Paragraph, Separator } from '@fs/zion-ui'

import HamburgerCloseIcon from './images/close-green.png'

export default function StationSignOutBox({ logoutCallback, toggleDrawer, email }) {
  const [t] = useTranslation()

  const signOutCSS = css`
    display: block;
    color: #979797;
    font-family: Verdana;
    font-size: 20px;
    margin-inline-start: 10px;
  `

  const signOutButtonCSS = css`
    background: none;
    border: none;
    padding: 0;
    cursor: pointer;
    display: flex;
    align-items: center;
  `

  const outerContainerCSS = css`
    background-color: #fdfdfd;
    padding: 22px;
    display: flex;
    flex-direction: column;
  `

  return (
    <div css={outerContainerCSS}>
      <div style={{ minHeight: '58px' }}>
        <button
          type="button"
          onClick={() => {
            toggleDrawer('right', true)
            logoutCallback()
          }}
          onKeyPress={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              toggleDrawer('right', true)
              logoutCallback()
            }
          }}
          css={signOutButtonCSS}
        >
          <img src={HamburgerCloseIcon} alt="Nav" css={{ width: '44px', outline: 'none' }} />
          <span css={signOutCSS}>{t('station.sign-out', 'Sign Out')}</span>
        </button>
      </div>
      {!!email && (
        <>
          <Paragraph>{t('station.discoveries-sent-to', 'Your discoveries from today were sent to:')}</Paragraph>
          <Separator size="sm" />
          <Paragraph> {email}</Paragraph>
          <Separator size="xxl" />
        </>
      )}

      <Separator size="xxl" />
      <Paragraph size="sm">{t('station.discover-more', 'Discover more at FamilySearch.org.')}</Paragraph>
    </div>
  )
}

StationSignOutBox.propTypes = {
  logoutCallback: func,
  toggleDrawer: func,
}
